import translate from '../../../i18n'
import { CorporateCreditsRequest } from '../../../pages/corporates-container/share-type'
import CreditsNotesForm from '../credits-notes-form/credits-notes-form'
import { Button, Modal } from 'antd'
import React from 'react'

interface DistributeCreditsModalProps {
  onFinish: (value: CorporateCreditsRequest) => void
  handleCancel: () => void
  open: boolean
  loading: boolean
  isTrialCorporate: boolean
}

const DistributeCreditsModal = (props: DistributeCreditsModalProps) => {
  return (
    <Modal
      open={props.open}
      footer={null}
      width={800}
      forceRender
      title={translate('corporate.credits.distribution')}
      onCancel={props.handleCancel}
      destroyOnHidden
    >
      <CreditsNotesForm
        loading={props.loading}
        onFinish={props.onFinish}
        showBufferPercentageInput
        showExpiredAtInput
        footerButton={<Button onClick={props.handleCancel}>{translate('cancel')}</Button>}
        isTrialCorporate={props.isTrialCorporate}
      />
    </Modal>
  )
}

export default DistributeCreditsModal
